import React, { FC, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clearToast } from './Store';
import { RootState } from '../../store/reducers';
import ToastMessage from './ToastMessage';
import { normalizeToastMessage } from '../../helpers/toastMessage';

const Toast: FC = () => {
	const dispatch = useDispatch();
	const [toast, setToast] = useState(false);
	let timeouts: any = null;

	const { isMessage, messageContent, messageType } = useSelector((state: RootState) => {
		const { isMessage = false, messageType = '', messageContent = {} } = state.toastStore;
		return {
			isMessage,
			messageType,
			messageContent,
		};
	});

	function toastTimeOut() {
		timeouts = setTimeout(() => {
			setToast(false);
			dispatch(clearToast());
			timeouts = null;
		}, 4000);
	}

	useEffect(() => {
		if (isMessage && Object.keys(messageContent).length !== 0) {
			setToast(true);
			toastTimeOut();
		}
		return () => {
			clearTimeout(timeouts);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isMessage]);

	const closeToast = () => {
		dispatch(clearToast());
		setToast(false);
	};

	function errorList(messageContent: any = {}) {
		const validation =
			Object.keys(messageContent).length === 0 ? (
				<li>something went wrong</li>
			) : (
				Object.keys(messageContent).map((e, i) => {
					const { message = '' } = messageContent[e] || {};
					return <li key={`e${i}`}>{normalizeToastMessage(message)}</li>;
				})
			);
		return <ul>{validation}</ul>;
	}

	return (
		<>
			{toast && (
				<ToastMessage openToast={toast} messageType={messageType} closeToast={closeToast}>
					<span style={{ wordBreak: 'break-all' }}>{errorList(messageContent)} </span>
				</ToastMessage>
			)}
		</>
	);
};

export default Toast;
